import React from 'react';
import { Grid, Typography, useMediaQuery } from '@mui/material';
import { poppins500 } from 'theme/common.style';

const AgencyBadge = ({
  name,
  variant = 'default',
  sx = {},
  typographySx = {},
}) => {
  const matchessm = useMediaQuery('(max-width: 600px)');
  const isBuyerCard = variant === 'buyerCard';
  const isSurvey = variant === 'survey';
  const isMarketPlace = variant === 'marketplace';
  const isSolicitor = variant === 'solicitor';

  return (
    <Grid
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: '#FFE512',
        minWidth: isBuyerCard ? '68px' : '141px',
        width: 'fit-content',
        padding: isBuyerCard
          ? '5px 5px'
          : isSurvey
          ? '14px 19px'
          : isMarketPlace
          ? '10px 8px'
          : '10px 10px',
        whiteSpace: (isBuyerCard || isSolicitor) && 'nowrap',
        ...sx,
      }}
    >
      <Typography
        sx={{
          ...poppins500,
          fontSize: isBuyerCard
            ? '10px'
            : isSurvey && !matchessm
            ? '20px'
            : isMarketPlace && !matchessm
            ? '20px'
            : isMarketPlace && matchessm
            ? '10px'
            : matchessm
            ? '12px'
            : '14px',
          fontStyle: 'italic',
          fontWeight: isBuyerCard ? 500 : 700,
          color: '#4B4B4B',
          ...typographySx,
        }}
      >
        {name}
      </Typography>
    </Grid>
  );
};

export default AgencyBadge;
